import { PublicClientApplication } from "@azure/msal-browser";

const {
  REACT_APP_AZURE_AD_CLIENT_ID,
  REACT_APP_AZURE_AD_TENANT_ID,
  REACT_APP_API_RESOURCE,
  REACT_APP_API_SCOPE,
} = process.env;

export const TENANT_ID =
  REACT_APP_AZURE_AD_TENANT_ID || "5dc645ed-297f-4dca-b0af-2339c71c5388";
export const CLIENT_ID =
  REACT_APP_AZURE_AD_CLIENT_ID || "f9607ab5-1b08-4282-be7d-e464af21059b";
// Use the backend app GUID as the resource (no api:// prefix). Override via env if needed.
export const API_RESOURCE =
  REACT_APP_API_RESOURCE || "f9607ab5-1b08-4282-be7d-e464af21059b";
export const API_SCOPE = REACT_APP_API_SCOPE || `${API_RESOURCE}/.default`;
export const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: window.location.origin,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
